import { MessageCircle } from "lucide-react";
import { waLink } from "@/lib/constants";
import { trackWhatsAppClick } from "@/lib/analytics";

export const WhatsAppButton = () => {
  return (
    <a
      data-testid="whatsapp-floating-btn"
      href={waLink("Hi, I'd like to enquire about wedding invitations.")}
      onClick={() => trackWhatsAppClick("floating")}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp us"
      className="fixed bottom-6 right-6 z-50 group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366]/30 animate-ping" />
      <span className="relative flex items-center gap-2 bg-[#25D366] text-white px-5 py-4 rounded-full shadow-2xl hover:scale-105 transition-transform duration-300">
        <MessageCircle className="w-5 h-5" strokeWidth={2.2} />
        <span className="hidden sm:inline text-[12px] font-medium tracking-[0.18em] uppercase">
          WhatsApp
        </span>
      </span>
    </a>
  );
};

export default WhatsAppButton;
